<div *ngIf="!form.valid && !form.pristine && formErrors.length" class="alert alert-danger">
      <p *ngFor="let error of formErrors">{{error}}</p>
</div>

